export default __webpack_public_path__ + "static/media/bigPlasticJar.7deeeb90.png";